import vanTwoSlide from "./index.vue";

/* istanbul ignore next */
vanTwoSlide.install = function(Vue) {
  Vue.component(vanTwoSlide.name, vanTwoSlide);
};

export default vanTwoSlide;
